module.exports = __webpack_public_path__ + "static/media/gator-modal-slide-2.aba22d59.png";